import { render, staticRenderFns } from "./ShipDagmarAaenDashboardWidget.vue?vue&type=template&id=a863d7ac&scoped=true"
import script from "./ShipDagmarAaenDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipDagmarAaenDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipDagmarAaenDashboardWidget.vue?vue&type=style&index=0&id=a863d7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863d7ac",
  null
  
)

export default component.exports